<template>
  <v-card class="elevation-12 ma-4">
    <v-toolbar dark color="primary">
      <v-toolbar-title>{{ $t("new-password.title") }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu :nudge-width="100">
        <template v-slot:activator="{ on }">
          <v-toolbar-title v-on="on">
            <span><flag :iso="$i18n.locale.split('-')[1]" /></span>
            <v-icon dark>arrow_drop_down</v-icon>
          </v-toolbar-title>
        </template>
        <v-list>
          <v-list-item
            v-for="item in Object.keys(this.$i18n.messages)"
            :key="item"
            @click="$i18n.locale = item">
            <v-list-item-title><flag :iso="item | localeToCountry" /> {{ $t('langNative.'+item) }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-card-text class="v-card__text">
      <v-alert :value="error" type="error" transition="scale-transition" >
        {{ $t("new-password.changeError") }}
      </v-alert>
      <v-alert :value="changed" type="success" transition="scale-transition" >
        {{ $t("new-password.changed") }}
      </v-alert>
      <v-form ref="form" v-model="valid" v-if="!changed">
        <v-text-field name="password" :label="$t('profile.password')" type="password" 
          v-model="user.Password" :rules="[rules.required, rules.passwordLength, rules.passwordNumerical]"></v-text-field>
        <v-text-field name="password" :label="$t('profile.repeatpassword')" type="password"
          v-model="user.ConfirmPassword" :rules="[rules.required, rules.passwordMatch]"></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions class="v-card__actions">
      <v-spacer></v-spacer>
      <v-btn color="primary" v-on:click="submitLogin" v-if="!changed" >{{ $t("new-password.change") }}</v-btn>
      <v-btn color="primary" to="/login" v-if="changed" >{{ $t("login.title") }}</v-btn>
    </v-card-actions>
    
  </v-card>
</template>

<script>
  import {
    VForm,
    VTextField,
    VCard,
    VCardActions,
    VCardText,
    VBtn,
    VAlert,
    VMenu
  } from 'vuetify/lib'
import fccapi from '../fccapi';

  export default {
    name: 'FCCNewPassword',
    data: () => ({
      drawer: null,
      user: {Password: "", ConfirmPassword: ""},
      incorrect: false,
      valid: false,
      error: false,
      changed: false
    }),
    methods: {
      submitLogin: function () {
        if(this.valid){
          var data = this.user;
          data.Code = this.$route.query.confirmation;
          data.Id = this.$route.query.user;
          fccapi.post("new-password", data).then(()=>{
            this.changed = true;
          }).catch(()=>{
              this.error = true;
          });
        }
        else{
          this.$refs.form.validate();
        }
      }
    },
    mounted: function(){
      var p = this.$route.query;
      if(!p.user && !p.confirmation) this.$router.push('/login');
    },
    props: {
      source: String
    },
    computed: {
      rules: function(){
        return {
          required: value =>  !!value || this.$t('registration.required'),
          passwordMatch: value => value == this.user.Password || this.$t('registration.passwordMismatch'),
          passwordLength: value => value.length >= 6 || this.$t('registration.passwordLength'),
          passwordNumerical: value => {
              const pattern = /[0-9]/
              return pattern.test(value) || this.$t('registration.passwordNumerical')
          }
        }
      }
    },
    components: {
      VCard,
      VForm,
      VTextField,
      VCardActions,
      VCardText,
      VBtn,
      VAlert,
      VMenu
    }
  }
</script>